<template>
  <span class="block h-2 w-2 rounded-full bg-primary-800" aria-hidden="true" />
</template>
